import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CustomShipViaAccountNumberState from "@tCooneyBrothers/Handlers/CustomShipViaAccountNumberState";
import { Draft } from "immer";

const initialState: CustomShipViaAccountNumberState = {
    isPlacingOrder: false,
    isApplyingPromotion: false,
    isCheckingOutWithPayPay: false,
    accountNumber: "",
    isCustomUnhandledPopUpOpen: false,
    isPreloadingData: false,
    poNumber: "",
    updateBillingAddress: false,
    isPromotionAppliedSuccess: false,
    isRemovingPromotion: false,
    isPromotionRemovedSuccess: false,
    isRemovingPromotions: false,
    isPromotionsRemovedSuccess: false,
    freightCarrier: "",
    paymetricIFrameIsSet: false,
    cartFreightTerms: "",
    cartFreightTermsSelected: false,
};
const customState = createTypedReducerWithImmer(initialState, {
    "Custom/CheckoutReview/SetAccountNumber": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { accountNumber: string },
    ) => {
        draft.accountNumber = action.accountNumber;
    },
    "Custom/Data/FailedCustomPopUp": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { openModal: boolean },
    ) => {
        draft.isCustomUnhandledPopUpOpen = action.openModal;
    },
    "Custom/Data/SetCloseUnhandledModel": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { closeModel: boolean },
    ) => {
        draft.isCustomUnhandledPopUpOpen = !action.closeModel;
    },
    "Custom/CheckoutReview/SetPoNumber": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { poNumber: string },
    ) => {
        draft.poNumber = action.poNumber;
    },
    "Custom/CheckoutShipping/SetBillingAddressUpdate": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { updateBillingAddress: boolean },
    ) => {
        draft.updateBillingAddress = action.updateBillingAddress;
    },
    "Custom/CheckoutReview/SetFreightCarrier": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { freightCarrier: string },
    ) => {
        draft.freightCarrier = action.freightCarrier;
    },
    "Custom/CheckoutReview/SetFreightTerms": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { cartFreightTerms: string },
    ) => {
        draft.cartFreightTerms = action.cartFreightTerms;
        draft.cartFreightTermsSelected = !!action.cartFreightTerms;
    },
    "Custom/CheckoutReview/SetFreightTermsSelected": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { cartFreightTermsSelected: boolean },
    ) => {
        draft.cartFreightTermsSelected = action.cartFreightTermsSelected;
    },
});
(reducers as any).customState = customState;

export type CustomState = {
    customState: CustomShipViaAccountNumberState;
} & ApplicationState;

type Reducers = {
    customState: typeof customState;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
